import firebase from 'firebase';

// const config = {
//   apiKey: process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASE_URL,
//   projectId: process.env.REACT_APP_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_APP_ID
// };

// DEV
const config = {
  apiKey: 'AIzaSyDjAeNP3lxreaqf_69X1REvvFzECUJNVOw',
  authDomain: 'crewpass-dev.firebaseapp.com',
  projectId: 'crewpass-dev',
  storageBucket: 'crewpass-dev.appspot.com',
  messagingSenderId: '454534822905',
  appId: '1:454534822905:web:5a86f86f8e82fec7ef5b28',
};

firebase.initializeApp(config);

export const { auth } = firebase;
export const db = firebase.firestore();
export const storage = firebase.storage();
